import Ribbon from "@/assets/ribbon-chart.svg";

import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

export const IntroLanding = () => {
  const { i18n, t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundColor: "rgb(255,255,255)",
        justifyContent: "start",
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          backgroundColor: "rgb(255,255,255)",
          justifyContent: "start",
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          gap: 20,
          maxWidth: 500,
          padding: 20,
        }}
      >
        <img
          src={Ribbon}
          style={{
            height: "50vh",
            width: "70vw",
            objectFit: "contain",
          }}
        />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 20,
            width: "100%",
          }}
        >
          <a
            href="mailto:hello@2-gift.com"
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 20,
              padding: "20px 40px",
              border: "1px solid black",
              borderRadius: 6,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {t("contact-us")}
          </a>
          <a
            href="/politica-privacidad"
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 20,
              padding: "20px 40px",
              border: "1px solid black",
              borderRadius: 6,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {t("privacy-policy")}
          </a>
        </div>
      </div>
    </div>
  );
};
